"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useRenderToast;

var _useWebChatAPIContext = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useRenderToast() {
  return (0, _useWebChatAPIContext.default)().toastRenderer;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VSZW5kZXJUb2FzdC50cyJdLCJuYW1lcyI6WyJ1c2VSZW5kZXJUb2FzdCIsInRvYXN0UmVuZGVyZXIiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFDQTs7OztBQUVlLFNBQVNBLGNBQVQsR0FBdUM7QUFDcEQsU0FBTyxxQ0FBdUJDLGFBQTlCO0FBQ0QiLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFJlbmRlclRvYXN0IH0gZnJvbSAnLi4vdHlwZXMvVG9hc3RNaWRkbGV3YXJlJztcbmltcG9ydCB1c2VXZWJDaGF0QVBJQ29udGV4dCBmcm9tICcuL2ludGVybmFsL3VzZVdlYkNoYXRBUElDb250ZXh0JztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlUmVuZGVyVG9hc3QoKTogUmVuZGVyVG9hc3Qge1xuICByZXR1cm4gdXNlV2ViQ2hhdEFQSUNvbnRleHQoKS50b2FzdFJlbmRlcmVyO1xufVxuIl19